import React, { useEffect } from 'react';
import { ProgressHeader } from './components/ProgressHeader/ProgressHeader';
import { StepsList, Step } from './components/StepsList/StepsList';
import { setProgressBarData, incrementStep, setSteps, useProgressBarData } from './context/progressBarAtoms';
import { TwoColumnLayout } from '../layouts/TwoColumnLayout';
import { LOADER_COMPLETE_DELAY, LOADER_STEP_TIME } from '../../consts';

interface Props {
  steps: Step[];
  onComplete?: () => void;
  background?: string;
  mainContentSpan?: number;
  mainCellStyle?: React.CSSProperties;
  sideCellStyle?: React.CSSProperties;
  isLoading?: boolean;
}

export const TwoColumnProgressBar: React.FC<Props> = ({
  steps,
  onComplete,
  background,
  mainContentSpan = 8,
  mainCellStyle,
  sideCellStyle,
  isLoading = false,
}) => {
  const { currentStep, isComplete } = useProgressBarData();

  useEffect(() => {
    // Initialize the progress bar state
    setSteps(steps);
    setProgressBarData({ background });
  }, [steps, background]);

  useEffect(() => {
    if (!steps.length || isComplete) {
      return;
    }

    const timer = setTimeout(() => {
      incrementStep();
    }, LOADER_STEP_TIME);

    return () => clearTimeout(timer);
  }, [steps, currentStep, isComplete]);

  useEffect(() => {
    if (isComplete && onComplete && !isLoading) {
      // Add a small delay to ensure the progress bar animation reaches 100% before calling onComplete
      const timer = setTimeout(() => {
        onComplete();
      }, LOADER_COMPLETE_DELAY);

      return () => clearTimeout(timer);
    }
  }, [isComplete, onComplete, isLoading]);

  return (
    <TwoColumnLayout
      mainContent={<ProgressHeader />}
      sideContent={<StepsList />}
      mainContentSpan={mainContentSpan}
      mainCellStyle={mainCellStyle}
      sideCellStyle={sideCellStyle}
    />
  );
};
